import { render, staticRenderFns } from "./callout.vue?vue&type=template&id=3368f326&"
import script from "./callout.vue?vue&type=script&lang=js&"
export * from "./callout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports